import { Component, Element, Prop, h } from '@stencil/core';
import { HTMLStencilElement } from '@stencil/core/internal';
import {IAceHeadlineTag} from '@ace/web-components';

@Component({
	tag: 'w2d-action-bar',
	styleUrl: './w2d-action-bar.scss',
	shadow: true,
})
export class W2dActionBar {
	@Prop() headline!: string;
	@Prop() headlineTag: IAceHeadlineTag = 'h2';
	@Element() hostElement: HTMLStencilElement;

	private renderSlot() {
		if (this.hostElement.innerHTML) {
			return (
				<div class='w2d-action-bar__actions'>
					<slot></slot>
				</div>
			);
		}
	}

	render() {
		return (
			<ace-section background-color='surface-solid--200' with-padding-top='false' with-padding-bottom='false' class='w2d-action-bar'>
				<div class='w2d-action-bar__content'>
					<ace-headline tag={this.headlineTag} type={'h2'} class='w2d-action-bar__headline'>{this.headline}</ace-headline>
					{this.renderSlot()}
				</div>
			</ace-section>
		);
	}
}
